import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';

export default function AdminRoute({ children }) {
  const { profile, loading } = useContext(AuthContext);
  const { language } = useLanguage();
  const isFr = language === 'fr';
  const t = (frText, enText) => (isFr ? frText : enText);

  if (loading) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-950 bg-mesh-gradient">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-slate-700 border-t-brand-500" />
        <p className="text-sm font-medium text-slate-400">{t("Vérification de l'accès…", 'Verifying access...')}</p>
      </div>
    );
  }

  if (!profile) {
    return <Navigate to="/login" replace />;
  }

  if (!profile?.isAdmin) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-slate-950 px-6 text-center">
        <div className="ui-panel max-w-md px-8 py-10">
          <h1 className="text-lg font-semibold text-white">{t('Accès restreint', 'Access restricted')}</h1>
          <p className="mt-2 text-sm text-slate-500">{t("Votre compte n'a pas l'autorisation d'ouvrir la console d'administration.", 'Your account does not have permission to open the admin console.')}</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
